//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'edit-cliente',
  props: {
    clienteEdit: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      cliente: {}
    }
  },
  methods: {
    async save () {
      const cliente = await this.$api.put('/api/cliente/' + this.cliente._id, this.cliente)
        .then(response => {
          if (response.data.error) {
            console.error(response.data)
          }
          return response.data
        })
        .catch(error => {
          console.error(error)
          return error
        })

      if (cliente && !cliente.error) {
        this.$emit('saved', cliente)
      }
      this.$emit('cancel')
    }
  },
  created () {
    this.cliente = JSON.parse(JSON.stringify(this.clienteEdit))
  }
}
